export default {
    namespaced: true,
    state: {
        all: [],
    },
    mutations: {
        setCartItems(state, payload) {
            let item = state.all.find((item) => {
                return item.build === payload.build;
            });
            if (item) {
                item.amount += 1;
            } else {
                state.all.push(payload);
            }

            this.commit('cart/setCartState', true);
        },
        setItemAmount(state, payload) {
            let item = state.all.find((item) => {
                return item.build === payload.build;
            });

            if (payload.newAmount === 0) {
                const confirmed = confirm('Weet u zeker dat u deze slang uit uw systeem wilt halen?');
                if (confirmed) {
                    state.all = state.all.filter((item) => {
                        return item.build !== payload.build;
                    });
                }

                return;
            }

            item.amount = payload.newAmount;
        },
    },
    actions: {}
}
